import axios from 'axios';
import { getToken } from '@/utilities/cookies';
const ApimApiClient = axios.create({
    baseURL: window.appConfig?.apimBaseUrl || import.meta.env.VITE_APIM_API_BASE_URL || '',
    headers: {
        'Content-Type': 'application/json',
    },
});
ApimApiClient.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers = config.headers ?? {};
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

export const isCancel = axios.isCancel;
export default ApimApiClient;